function Mapper () {
  function quickSearchResult (data) {
    return data.products.map(result => {
      return {
        id: result.id_token,
        slug: result.slug,
        name: result.product_name,
        category: result.category_name,
        image: result.image,
        price: result.price,
        rating: result.supplier_rating,
        stockInUsa: result.stock_in_usa
      }
    })
  }

  function product (data) {
    let product = data.product
    return {
      result: data.result,
      id: product.id_token,
      slug: product.slug,
      colors: product.colors,
      images: product.images.map(img => img.url),
      incoTerms: product.inco_terms,
      materials: product.materials,
      brand: product.product_information.brand,
      categoryName: product.product_information.category_name,
      country: product.product_information.country,
      description: product.product_information.description,
      displayMoq: product.product_information.display_moq,
      highestExwPrice: product.product_information.highest_exw_price,
      highestFobPrice: product.product_information.highest_fob_price,
      lowestExwPrice: product.product_information.lowest_exw_price,
      lowestFobPrice: product.product_information.lowest_fob_price,
      minimumOrderQuantity: parseInt(product.product_information.minimum_order_quantity),
      modelNumber: product.product_information.model_number || 'N/A',
      paymentTerms: product.product_information.payment_terms || 'N/A',
      price: product.product_information.price || 'N/A',
      name: product.product_information.product_name || 'N/A',
      quantityIncrement: parseInt(product.product_information.quantity_increment),
      shortDescription: product.product_information.short_description || 'N/A',
      sku: product.product_information.sku || 'N/A',
      stockInUsa: product.product_information.stock_in_usa,
      unit: product.product_information.unit || 'N/A',
      packaging: {
        size: product.packaging.package_size,
        type: product.packaging.package_type,
        weight: product.packaging.package_weight,
        packagesPerContainer: product.packaging.packages_per_container,
        unitsPerPackage: product.packaging.units_per_package
      },
      pricing: product.pricing.map(price => {
        return {
          displayExwPrice: price.display_exw_price,
          displayFobPrice: price.display_fob_price,
          exwPrice: price.exw_price,
          fobPrice: price.fob_price,
          maxQuantity: price.quantity_max,
          leadTimeInDays: price.lead_time_in_days
        }
      }),
      specification: {
        dangerous: product.specification.dangerous_goods,
        displaySize: product.specification.display_size,
        displayWeight: product.specification.display_weight,
        layer: product.specification.layer,
        shape: product.specification.shape
      },
      standards: product.standards.map(standard => {
        return {
          type: standard.standard_type,
          url: standard.url
        }
      }),
      supplier: {
        id: product.supplier.supplier_id_token,
        name: product.supplier.company_name,
        rating: product.supplier.supplier_rating
      },
      certificates: product.certificates.map(certificate => {
        return {
          type: certificate.certificate_type,
          url: certificate.url
        }
      }),
      relatedProducts: data.similar_products.map(item => {
        return {
          id: item.id_token,
          slug: item.slug,
          name: item.product_name,
          category: item.category_name,
          images: item.images ? item.images.map(img => img.url) : null,
          price: item.price,
          stockInUsa: item.stock_in_usa,
          supplier: {
            id: item.supplier.supplier_id_token,
            name: item.supplier.company_name,
            rating: item.supplier.supplier_rating
          }
        }
      })
    }
  }

  function searchResult(data) {
    return {
      currentPage: data.current_page,
      totalResults: data.total_results,
      products: data.products.map(result => {
        return {
          id: result.id_token,
          slug: result.slug,
          name: result.product_name,
          category: result.category_name,
          images: result.images ? result.images.map(img => img.url) : null,
          price: result.price,
          displayMoq: result.display_moq,
          stockInUsa: result.stock_in_usa,
          supplier: {
            id: result.supplier.supplier_id_token,
            name: result.supplier.company_name,
            rating: result.supplier.supplier_rating
          }
        }
      })
    }
  }

  function setFilters (data) {
    return {
      result: data.result,
      filters: {
        minPrice: data.filters.min_price,
        maxPrice: data.filters.max_price,
        productCertification: data.filters.product_certification,
        supplierCertification: data.filters.supplier_certification,
        supplierLocations: data.filters.supplier_locations,
        stockInUsaFilter: data.filters.stock_in_usa_filter,
        breadcrumbs: data.filters.category_breadcrumbs.map(breadcrumbs => {
          return{
            categoryName: breadcrumbs.category_name,
            categorySlug: breadcrumbs.category_slug,
            tokenId: breadcrumbs.id_token
          } 
        }),
        categories: data.filters?.categories?.map(cat => {
          return {
            id: cat.id_token,
            name: cat.category_name,
            slug: cat.category_slug,
            subCategories: cat.sub_categories.map(sub => {
              return {
                id: sub.id_token,
                name: sub.category_name,
                slug: sub.category_slug,
              }
            })
          }
        }) || null
      }
    }
  }

  function featureProduct (data) {
    return {
      id: data.id_token,
      slug: data.slug,
      name: data.product_name,
      category: data.category_name,
      image: data.image,
      price: data.price,
      supplierRating: data.supplier_rating,
      featureStartDate: data.featuring_start_date || null,
      featureEndDate: data.featuring_end_date || null,
      productAddedOn: data.product_added_on || null
    }
  }

  function hotProducts (data) {
    return data.categories.map(category => {
      return {
        id: category.category_id_token,
        name: category.category_name,
        products: category.products.map(product => featureProduct(product))
      }
    })
  }

  return {
    quickSearchResult,
    product,
    searchResult,
    setFilters,
    featureProduct,
    hotProducts
  }
}

export default Mapper()
